import {
  ShieldCheck,
  Sparkles,
  Receipt,
  Warehouse,
  BellRing,
  Headphones,
  CheckCircle2,
} from 'lucide-react'

export default function WhyMogesappSection() {
  const items = [
    {
      icon: Sparkles,
      title: 'Simple à prendre en main',
      desc: 'Une interface claire pour démarrer rapidement, même sans équipe technique.',
    },
    {
      icon: Receipt,
      title: 'Pensé pour la vente réelle',
      desc: 'Factures, paiements, dettes clients et encaissements sont au cœur du produit.',
    },
    {
      icon: Warehouse,
      title: 'Stock mieux organisé',
      desc: 'Vous suivez vos produits, vos dépôts et vos mouvements avec plus de clarté.',
    },
    {
      icon: BellRing,
      title: 'Relances utiles',
      desc: 'Vous pouvez rappeler les clients qui doivent encore payer, sans gérer tout à la main.',
    },
    {
      icon: ShieldCheck,
      title: 'Plus de contrôle',
      desc: 'Vous voyez mieux ce qui entre, ce qui sort et ce qui reste à récupérer.',
    },
    {
      icon: Headphones,
      title: 'Support réactif',
      desc: 'Vous n’êtes pas seul si vous avez besoin d’aide pour avancer.',
    },
  ]

  return (
    <section className='border-t'>
      <div className='mx-auto max-w-7xl px-4 py-20'>
        <div className='grid gap-10 lg:grid-cols-[1.1fr_.9fr] lg:items-center'>
          <div>
            <div className='inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs text-muted-foreground'>
              <Sparkles className='h-3.5 w-3.5 text-primary' />
              Pourquoi choisir MOGESAPP
            </div>

            <h2 className='mt-4 text-3xl md:text-4xl font-bold tracking-tight'>
              Une application conçue pour vous faire gagner du temps et mieux
              suivre votre commerce
            </h2>

            <p className='mt-4 text-muted-foreground max-w-2xl'>
              MOGESAPP vous aide à travailler avec plus d’ordre, plus de
              visibilité et moins d’erreurs. Vous facturez mieux, vous suivez
              mieux vos paiements, vous contrôlez mieux votre stock et vous
              récupérez plus facilement ce qui vous est dû.
            </p>

            <div className='mt-8 grid gap-4 sm:grid-cols-2'>
              {items.map((item) => {
                const Icon = item.icon

                return (
                  <div
                    key={item.title}
                    className='rounded-2xl border bg-background p-5'
                  >
                    <div className='flex items-center gap-3'>
                      <div className='rounded-xl bg-primary/10 p-2.5'>
                        <Icon className='h-4.5 w-4.5 text-primary' />
                      </div>
                      <h3 className='font-semibold'>{item.title}</h3>
                    </div>

                    <p className='mt-3 text-sm text-muted-foreground'>
                      {item.desc}
                    </p>
                  </div>
                )
              })}
            </div>
          </div>

          <div className='rounded-3xl border bg-muted/30 p-6 md:p-8'>
            <h3 className='text-xl font-semibold'>
              Ce que vos clients et votre équipe ressentent rapidement
            </h3>

            <div className='mt-6 space-y-4'>
              {[
                'Les ventes sont mieux suivies.',
                'Les paiements en attente sont plus visibles.',
                'Le stock devient plus lisible.',
                'Les informations ne sont plus dispersées partout.',
                'Les décisions quotidiennes deviennent plus faciles.',
              ].map((point) => (
                <div
                  key={point}
                  className='flex items-start gap-3 rounded-xl border bg-background p-4'
                >
                  <CheckCircle2 className='mt-0.5 h-5 w-5 text-primary shrink-0' />
                  <p className='text-sm text-muted-foreground'>{point}</p>
                </div>
              ))}
            </div>

            <div className='mt-6 rounded-2xl border bg-background p-5'>
              <div className='text-sm font-medium'>En clair</div>
              <p className='mt-2 text-sm text-muted-foreground'>
                MOGESAPP ne sert pas seulement à enregistrer des données. Il
                sert à vous aider à mieux piloter votre activité jour après
                jour.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
